import { render } from "./ShopCategory.vue?vue&type=template&id=2b5af7a9"
import script from "./ShopCategory.vue?vue&type=script&lang=js"
export * from "./ShopCategory.vue?vue&type=script&lang=js"

import "./ShopCategory.vue?vue&type=style&index=0&id=2b5af7a9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__